export const projects = [
  {
    id: '01',
    name: 'Forkfolio',
    desc: 'A cloud-native recipe-sharing platform built for scale, personalization, and fast user experiences. Developed with a full-stack architecture, secure APIs, and AI-powered recommendation features.',
    tags: ['React', 'Node.js', 'MongoDB', 'AWS'],
    primaryTags: ['React', 'Node.js'],
    type: 'fullstack',
    link: 'https://forkfolio-connect.vercel.app/',
  },
  {
    id: '02',
    name: 'Income Firewall',
    desc: 'A fintech project designed to help people manage irregular income with more structure and visibility. Built around budgeting, planning, and decision support for users who need better control over fluctuating cash flow.',
    tags: ['React', 'TypeScript', 'Node.js', 'Fintech'],
    primaryTags: ['React', 'TypeScript'],
    type: 'fullstack',
    link: 'https://income-firewall.vercel.app/',
  },
  {
    id: '03',
    name: 'TaxRadar',
    desc: 'An AI-powered deduction intelligence tool for freelancers and small business owners. Users can upload bank statement CSVs or receipt images, and the system classifies transactions, flags likely deductions, explains them, and generates accountant-ready PDF reports.',
    tags: ['Next.js', 'FastAPI', 'Python', 'TypeScript'],
    primaryTags: ['Next.js', 'FastAPI'],
    type: 'fullstack',
    link: 'https://taxradar-ai.vercel.app/',
  },
  {
    id: '04',
    name: 'Multi-Style Text Generation',
    desc: 'An end-to-end NLP platform that rewrites text across multiple tones using fine-tuned transformer models. Built with a FastAPI inference layer, a Next.js frontend, and an evaluation pipeline for generated outputs.',
    tags: ['Python', 'FastAPI', 'Next.js', 'PyTorch'],
    primaryTags: ['Python', 'FastAPI'],
    type: 'ml',
    link: '#',
  },
  {
    id: '05',
    name: 'PPTBuddy',
    desc: 'An AI-powered document transformation tool that converts PDFs into presentation-ready slides. Built to simplify content extraction, structuring, and presentation generation through an intuitive workflow.',
    tags: ['Python', 'AI', 'Document Processing', 'Web App'],
    primaryTags: ['Python'],
    type: 'ml',
    link: '#',
  },
];